import WithGASetup from '../WithGASetup';
import DisableAccount from './DisableAccount';

export default WithGASetup(DisableAccount);
